export default __webpack_public_path__ + "static/media/Rauch&Gursky_Still_3.63706e0f.jpg";